<template>
  <div class="recommend">
    <div class="flex">
      <div class="title">
        <span>信息发布</span>
      </div>
    </div>
    <div class="block">
      <ul class="flex" style="margin: 13px 47px;">
        <li class="one" v-for="(item,index) in data" @click="jump(`xinxiDetail?id=${item.id}`)">
          <img :src="item.image">
          <div class="content">
            <div style="margin-bottom: 40px;">{{item.title}}</div>
            <!-- <div>{{item.send_time}}</div> -->
          </div>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
  import {
    jump
  } from '../../../static/function.js'
  export default {
    data() {
      return {
        data: []
      }
    },
    created() {
      this.$http.index().then(res => {
        for (let i = 0; i < res.data.news_list.length; i++) {
          res.data.news_list[i].image = this.$imgUrl + res.data.news_list[i].thumb + ''
        }
        this.data = res.data.news_list
      })
    }
  }
</script>

<style scoped lang="scss">
  $color:'#C10B17';

  ul {
    margin-top: 30px;
  }

  li {
    /* width: 100%; */
    margin-bottom: 23px;
    text-align: left;
  }

  .hot {
    color: #FFA200;
    margin-left: 120px;
  }

  .rank {
    width: 20px;
    height: 20px;
    background: #FF0000;
    display: inline-block;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
  }

  .rank1 {
    background: #FF7F7F;
  }

  .rank2 {
    background: #FFCCCC;
  }

  .rank3 {
    background: #F2F2F2;
  }

  .more {
    display: inline-block;
    float: right;
  }

  .right {
    width: 300px;
    float: left;
    margin-top: 33px;
    margin-left: 40px;
  }

  .block {
    margin: 51px 20 0 26px;
  }

  .left {
    margin-top: 31px;
    width: 70%;
    float: left;
  }

  .title {
    width: 100px;
    position: relative;
    line-height: 18px;
    margin-left: 30px;
  }

  .title1 {
    /*  width: 200px; */
    position: relative;
    line-height: 18px;
  }

  .title::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: $color;
  }

  .title1::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: #19CACA;
  }

  .recommend {
    width: 1280px;
    height: 400px;
    background: #FFFFFF;
    margin: 22px auto;
    overflow: hidden;
    box-shadow: 0px 1px 29px 1px rgba(0, 0, 0, 0.03);
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .one {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content {
    width: 200px;
    height: 100px;
    margin-top: 30px;
    text-align: left;
    margin-left: 14px;
  }

  .content div:nth-child(1) {
    height: 18px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .content div:nth-child(2) {
    width: 177px;
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin: 11px 0 11px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .content div:nth-child(3) {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }

  .one img {
    width: 136px;
    height: 93px;
    float: left;
    border-radius: 10px;
  }

  .flex {
    margin: 13px 0px;
    justify-content: space-between;
  }

  .flex li {
    /* width: 140px; */
    list-style: none;
    text-align: center;
  }

  img {
    width: 100px;
    height: 80px;
    display: block;
    margin: 40px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/info.vue